import { type TextProps } from './createTypography';
import {
  bodyBold100,
  bodyBold150,
  bodyBold200,
  bodyRegular50,
  bodyRegular100,
  bodyRegular150,
  bodyRegular200,
  componentTableTextHeadingNew,
  headingBlack800,
  headingBold300,
  headingBold400,
  headingBold600,
  headingBold800,
  headingBold1000,
  headingLight800,
  headingLight1000,
  labelBold100,
  labelBold150,
  labelBold200,
  labelMedium100,
  labelMedium150,
  labelMedium200,
  linkRegular50,
  linkRegular100,
  linkRegular150,
  linkRegular200,
  numericRegular400,
  numericRegular600,
} from './typography';
import { breakpoints } from '@thrivent/midwest-shared';
import styled from 'styled-components';

const remDivider = 16;

export const MDSText = {
  HeroXl: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h1',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBlack800.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBlack800.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBlack800.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBlack800.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold1000.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold1000.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold1000.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold1000.rem] / remDivider}rem;
    }
  `,

  HeroLg: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h1',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold600.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold600.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold800.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold800.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold800.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold800.rem] / remDivider}rem;
    }
  `,

  HeroMd: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h1',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold400.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold400.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold400.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold400.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold600.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold600.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold600.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold600.rem] / remDivider}rem;
    }
  `,

  HeroSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h2',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold200.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold400.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold400.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold400.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold400.rem] / remDivider}rem;
    }
  `,

  TitleXl: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h2',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold600.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold600.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBlack800.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBlack800.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBlack800.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBlack800.rem] / remDivider}rem;
    }
  `,

  TitleLg: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h2',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold400.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold400.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold400.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold400.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold600.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold600.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold600.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold600.rem] / remDivider}rem;
    }
  `,

  TitleMd: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h2',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold400.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold400.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold400.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold400.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold400.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold400.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold400.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold400.rem] / remDivider}rem;
    }
  `,

  TitleSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'h2',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingBold300.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingBold300.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingBold300.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingBold300.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingBold300.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingBold300.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingBold300.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingBold300.rem] / remDivider}rem;
    }
  `,

  DataLg: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[headingLight800.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        headingLight800.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[headingLight800.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[headingLight800.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[headingLight1000.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          headingLight1000.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[headingLight1000.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[headingLight1000.rem] / remDivider}rem;
    }
  `,

  DataMd: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[numericRegular600.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        numericRegular600.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[numericRegular600.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[numericRegular600.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[numericRegular600.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          numericRegular600.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[numericRegular600.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[numericRegular600.rem] / remDivider}rem;
    }
  `,

  DataSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[numericRegular400.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        numericRegular400.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[numericRegular400.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[numericRegular400.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[numericRegular400.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          numericRegular400.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[numericRegular400.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[numericRegular400.rem] / remDivider}rem;
    }
  `,

  Subtitle: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold150.rem] / remDivider}rem;

    ${breakpoints.desktop} {
      font-family: ${(p) =>
        p.theme.font[bodyBold200.font as keyof typeof p.theme.font]};
      font-weight: ${(p) =>
        p.theme.fontWeight.primary[
          bodyBold200.weight as keyof typeof p.theme.fontWeight.primary
        ]};
      line-height: ${(p) =>
        p.theme.lineHeight[bodyBold200.lineHeight] / remDivider}rem;
      font-size: ${(p) => p.theme.size[bodyBold200.rem] / remDivider}rem;
    }
  `,

  BodyHeavyDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold200.rem] / remDivider}rem;
  `,

  BodyHeavySm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold150.rem] / remDivider}rem;
  `,

  BodyHeavyXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyBold100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyBold100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyBold100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyBold100.rem] / remDivider}rem;
  `,

  BodyMediumDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular200.rem] / remDivider}rem;
  `,

  BodyMediumSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular150.rem] / remDivider}rem;
  `,

  BodyMediumXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular100.rem] / remDivider}rem;
  `,

  BodyRegDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular200.rem] / remDivider}rem;
  `,

  BodyRegSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular150.rem] / remDivider}rem;
  `,

  BodyRegXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular100.rem] / remDivider}rem;
  `,

  RegDefaultLink: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular200.rem] / remDivider}rem;
  `,

  RegSmLink: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular150.rem] / remDivider}rem;
  `,

  RegXsLink: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular100.rem] / remDivider}rem;
  `,

  MiniDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[bodyRegular50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        bodyRegular50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[bodyRegular50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[bodyRegular50.rem] / remDivider}rem;
  `,

  MiniDefaultLink: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[linkRegular50.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        linkRegular50.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[linkRegular50.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[linkRegular50.rem] / remDivider}rem;
  `,

  //Old Typo Styles

  TextInterfaceHeavyDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold200.rem] / remDivider}rem;
  `,

  TextInterfaceHeavySmall: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold150.rem] / remDivider}rem;
  `,

  TextInterfaceHeavyXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold100.rem] / remDivider}rem;
  `,

  TextInterfaceSemiDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold200.rem] / remDivider}rem;
  `,

  TextInterfaceSemiSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold150.rem] / remDivider}rem;
  `,
  TextInterfaceSemiXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelBold100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelBold100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelBold100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelBold100.rem] / remDivider}rem;
  `,

  TextInterfaceMediumDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium200.rem] / remDivider}rem;
  `,

  TextInterfaceMediumSmall: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium150.rem] / remDivider}rem;
  `,

  TextInterfaceMediumXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium100.rem] / remDivider}rem;
  `,

  TextInterfaceRegularDefault: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium200.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium200.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium200.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium200.rem] / remDivider}rem;
  `,

  TextInterfaceRegularSm: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium150.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium150.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium150.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium150.rem] / remDivider}rem;
  `,

  TextInterfaceRegularXs: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[labelMedium100.font as keyof typeof p.theme.font]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        labelMedium100.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[labelMedium100.lineHeight] / remDivider}rem;
    font-size: ${(p) => p.theme.size[labelMedium100.rem] / remDivider}rem;
  `,

  ComponentTableTextHeading: styled.div.attrs(({ as }: TextProps) => ({
    as: as || 'span',
  }))`
    font-family: ${(p) =>
      p.theme.font[
        componentTableTextHeadingNew.font as keyof typeof p.theme.font
      ]};
    font-weight: ${(p) =>
      p.theme.fontWeight.primary[
        componentTableTextHeadingNew.weight as keyof typeof p.theme.fontWeight.primary
      ]};
    line-height: ${(p) =>
      p.theme.lineHeight[componentTableTextHeadingNew.lineHeight] /
      remDivider}rem;
    font-size: ${(p) =>
      p.theme.size[componentTableTextHeadingNew.rem] / remDivider}rem;
  `,
};
